import CommonLandingContainer from 'src/components/landingComponents/containers/common';
import styles from './instruction.module.scss';
import {
  Heading1,
  Heading2,
  Title,
  SubTitle,
  Body,
  SmallText,
  SecondaryText,
  Info,
  Button,
  Heading3,
} from 'src/components/landingComponents/typography';
import InfoPanel from 'src/components/landingComponents/containers/infoPanel';
import AnimatedBox from 'src/components/landingComponents/containers/animatedScroll';
import { getClassName } from 'src/Core/utility/jsx';
import { ReactComponent as Circles } from 'src/assets/img/landing/twoCircles.svg';
// import hands from 'src/assets/img/landing/roboAndHumanHands.png';
import LandingButton from 'src/components/landingComponents/button';
import { useNavigate } from 'react-router-dom';

const Instructions = () => {
  return (
    <CommonLandingContainer className={styles.container}>
      <Heading2 className={styles.header} accent>
        Как пользоваться системой
      </Heading2>
      <div className={styles.mainInfo}>
        <Instruction />
        <Hands />
      </div>
    </CommonLandingContainer>
  );
};

export default Instructions;

const Hands = () => {
  const history = useNavigate();

  return (
    <AnimatedBox className={getClassName([styles.handsContainer])}>
      {/* <img className={styles.hands} src={hands} alt="" /> */}
      <Circles className={styles.handsCircles} alt="" />
      <div className={styles.startButon}>
        <LandingButton
          variant="contained"
          href='/questions'
          // onClick={() =>
          //   history(`/questions`)
          // }
        >
          <Button>Начать работу</Button>
        </LandingButton>
      </div>
    </AnimatedBox>
  );
};

const Instruction = () => {
  return (
    <div className={getClassName([styles.instructionTextBlocks])}>
      <InfoBlock
        title="01"
        accentText="Нажмите «Загрузить файл»"
        text=" и выберите нужный PDF-документ с вашими анализами"
      ></InfoBlock>
      <InfoBlock
        title="02"
        delay={0.2}
        accentText="При необходимости дополните данные через раскрывающийся список "
        text="«Внесение данных вручную». Рекомендуем сразу указать ваш пол — это важно для корректной работы многих алгоритмов"
      ></InfoBlock>
      <InfoBlock
        title="03"
        accentText="Нажмите кнопку «Анализ» "
        text=" и получите подробный результат"
      ></InfoBlock>
      <InfoBlock
        title="04"
        delay={0.2}
        accentText="Если система не смогла распознать какое-либо поле,"
        text=" оно будет выделено красным цветом и выведено наверх для вашего внимания"
      ></InfoBlock>
    </div>
  );
};

const InfoBlock = ({ title, accentText, text, delay }) => {
  return (
    <AnimatedBox className={styles.instructionInfo} delay={delay}>
      <InfoPanel Header={() => <Body>{title}</Body>}>
        <SecondaryText>
          <span className={styles.instrAccentText}>{accentText}</span>
          {text}
        </SecondaryText>
      </InfoPanel>
    </AnimatedBox>
  );
};
